import React, { useState, useEffect } from 'react';
import './Navbar.css';
import axios from 'axios';

function Navbar() {
  // State to manage the sidebar visibility
  const [isSidebarVisible, setSidebarVisible] = useState(false);
  // State to manage the visibility of the "Copied" notification
  const [isCopied, setIsCopied] = useState(false);
  const [url, setUrl] = useState('');

  useEffect(() => {
    // Fetch the URL from the JSON file using axios
    axios.get('/data/data.json') // Assuming the JSON is located in the public/data folder
      .then(response => {
        console.log(response.data);
        // Set the URL state properly
        setUrl(response.data.websiteUrl);
      })
      .catch(err => {
        console.error('Error fetching the URL', err);
      });
  }, []);

  // Function to show the sidebar
  const showSidebar = () => {
    setSidebarVisible(true);
  };

  // Function to hide the sidebar
  const hideSidebar = () => {
    setSidebarVisible(false);
  };

  // Function to copy the URL to the clipboard and show notification
  const copyToClipboard = () => {
    navigator.clipboard.writeText(url).then(() => {
      setIsCopied(true);
      // Hide the notification after 3 seconds
      setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    }).catch(err => {
      console.error('Failed to copy the URL:', err);
    });
  };

  useEffect(() => {
    // Function to highlight the active navigation link
    const navHighlighter = () => {
      const sections = document.querySelectorAll("section[id]");
      const scrollY = window.pageYOffset;

      sections.forEach(current => {
        const sectionHeight = current.offsetHeight;
        const sectionTop = current.offsetTop - 50;
        const sectionId = current.getAttribute("id");

        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
          document.querySelector(`.nav__menu a[href*=${sectionId}]`).classList.add("active-link");
        } else {
          document.querySelector(`.nav__menu a[href*=${sectionId}]`).classList.remove("active-link");
        }
      });
    };

    // Add scroll event listener
    window.addEventListener('scroll', navHighlighter);

    // Call navHighlighter initially to set the active link on load
    navHighlighter();

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('scroll', navHighlighter);
    };
  }, []);

  return (
    <div>
      {/* Toggle button to show sidebar */}
      <div className="nav__toggle" onClick={showSidebar}>
        <i className="uil uil-bars"></i>
      </div>

      {/* Sidebar */}
      <aside className={`sidebar ${isSidebarVisible ? 'show-sidebar' : ''}`}>
        <nav className="nav">
          <div className="nav__logo">
            <a href="index.html" className="nav__logo-text">PK</a>
          </div>

          <div className="nav__menu">
            <div className="menu">
              <ul className="nav__list">
                <li className="nav__item">
                  <a href="#home" className="nav__link">Home</a>
                </li>
                <li className="nav__item">
                  <a href="#about" className="nav__link">About</a>
                </li>
                <li className="nav__item">
                  <a href="#skills" className="nav__link">Skills</a>
                </li>
                <li className="nav__item">
                  <a href="#work" className="nav__link">Work</a>
                </li>
                <li className="nav__item">
                  <a href="#contact" className="nav__link">Contact</a>
                </li>
              </ul>
            </div>
          </div>

          {/* Share button */}
          <div className="btn__share">
            <a href="#!" onClick={copyToClipboard}>
              <i className="uil uil-share-alt social__share"></i>
            </a>
          </div>

          {/* Close button to hide sidebar */}
          <div className="nav__close" onClick={hideSidebar}>
            <i className="uil uil-times"></i>
          </div>
        </nav>
      </aside>

      {/* Notification Box */}
      {isCopied && (
        <div className="notification-box">
          Copied!
        </div>
      )}
    </div>
  );
}

export default Navbar;
